<template>
    <div v-if="form && form.errors.hasOwnProperty(field)" class="text-red-500 text-xs mt-1"
         v-html="form.errors[field]"/>
</template>

<script>
export default {
    name: 'has-error',

    props: {
        form: {
            type: Object,
            required: true,
        },

        field: {
            type: String,
            required: true,
        },
    },
};
</script>
